import axiosInstance from 'axiosInstance';

export const fetchIntegrationsSummary = async () => {
  const response = await axiosInstance.get('integrations/summary');
  return response.data;
};

const openOAuthPopup = (url) => {
  return new Promise((resolve, reject) => {
    const popup = window.open(url, 'mercadolibre-integration', 'width=930,height=850');

    if (!popup) {
      reject(new Error('popup_blocked'));
      return;
    }

    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data && typeof event.data === 'object' && ('success' in event.data)) {
        cleanup();
        if (event.data.success) {
          resolve(event.data);
        } else {
          reject(new Error(event.data.error || 'integration_failed'));
        }
      }
    };

    const pollTimer = setInterval(() => {
      if (popup.closed) {
        cleanup();
        resolve({ closed: true });
      }
    }, 500);

    const cleanup = () => {
      window.removeEventListener('message', onMessage);
      clearInterval(pollTimer);
    };

    window.addEventListener('message', onMessage);
  });
};

export const startMercadoLibreIntegration = async () => {
  const response = await axiosInstance.get('integrations/mlapi/getAuthorizationURL');
  return openOAuthPopup(response.data.url);
};

export const startMercadoLibreIntegrationForAccount = async integrationId => {
  const query = integrationId ? `?integration_id=${integrationId}` : '';
  const response = await axiosInstance.get(`integrations/mlapi/getAuthorizationURL${query}`);
  return openOAuthPopup(response.data.url);
};

export const removeMercadoLibreIntegration = async integrationId => {
  const response = await axiosInstance.post('integrations/mlapi/remove', {
    integration_id: integrationId || null
  });
  return response.data;
};

export const testMercadoLibreIntegration = async integrationId => {
  const response = await axiosInstance.get(`integrations/mlapi/test?integration_id=${integrationId}`);
  return response.data;
};
